import React from 'react';
import { toast } from 'react-toastify';
import { ToastContent } from '../ToastContent/index.js';
import { TOAST_DEFAULT_CONFIG } from '../ToastPortal/index.js';
import { ToastIcon } from '../ToastIcon/index.js';

const notify = ({
  title,
  description,
  link,
  type: toastType,
  options = {}
}) => {
  if (toastType === "success")
    return toast.success(
      /* @__PURE__ */ React.createElement(ToastContent, { title, description, link }),
      { ...TOAST_DEFAULT_CONFIG, ...options }
    );
  if (toastType === "error")
    return toast.error(
      /* @__PURE__ */ React.createElement(ToastContent, { title, description, link }),
      { ...TOAST_DEFAULT_CONFIG, ...options }
    );
  if (toastType === "info")
    return toast.info(
      /* @__PURE__ */ React.createElement(ToastContent, { title, description, link }),
      { ...TOAST_DEFAULT_CONFIG, ...options }
    );
  if (toastType === "refresh")
    return toast(
      /* @__PURE__ */ React.createElement(ToastContent, { title, description, link }),
      {
        ...TOAST_DEFAULT_CONFIG,
        icon: ({ type, ...props }) => /* @__PURE__ */ React.createElement(ToastIcon, { type: "refresh", ...props }),
        ...options
      }
    );
  if (toastType === "waiting")
    return toast(
      /* @__PURE__ */ React.createElement(ToastContent, { title, description, link }),
      {
        ...TOAST_DEFAULT_CONFIG,
        icon: ({ type, ...props }) => /* @__PURE__ */ React.createElement(ToastIcon, { type: "waiting", ...props }),
        ...options
      }
    );
  if (toastType === "warning")
    return toast(
      /* @__PURE__ */ React.createElement(ToastContent, { title, description, link }),
      {
        ...TOAST_DEFAULT_CONFIG,
        icon: ({ type, ...props }) => /* @__PURE__ */ React.createElement(ToastIcon, { type: "warning", ...props }),
        ...options
      }
    );
  return toast.info(
    /* @__PURE__ */ React.createElement(ToastContent, { title, description, link }),
    { ...TOAST_DEFAULT_CONFIG, ...options }
  );
};

export { notify };
//# sourceMappingURL=toast.js.map
